import React from 'react';
import PropTypes from 'prop-types';

import { CarouselProvider } from '$contexts/carousel';
import Carousel, { CarouselNavigation, CarouselSlide } from '$partials/ui/carousel';
import ModuleTestimonialItem from './testimonial-item';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleTestimonialsCarousel = ({
    title,
    parent,
    testimonials = {}
}) => {
    if (!testimonials.items) { return null;}
    if (testimonials.items.length === 1 ) {
        return (
            <ModuleTestimonialItem
                {...testimonials.items?.[0]} />
        );
    }

    // manually duplicate slides if total slides is <= 3
    const items = testimonials.items.length <= 3 ? testimonials.items.concat(testimonials.items) : testimonials.items;
    return (
        <div className={`bg-white relative overflow-hidden ${parent === 'Home' ? 'py-40 md:py-50' : parent === 'Detail' ? 'py-20 md:py-30' : 'py-40 md:py-60'}`}>
            <div className='layout-container'>

                <div className='bg-white'>
                    <div className='bg-white overflow-hidden w-screen max-w-screen left-1/2 relative -translate-x-1/2 mt-40'>
                        <CarouselProvider swiperConfig={{
                            loop: true
                        }}>
                            <div className='layout-container flex relative'>
                                <div className={`px-10 sm:px-5 md:px-10 gap-10 sm:gap-0 w-full flex flex-wrap items-center ${title ? 'justify-between' : 'justify-end'}`}>
                                    {title && (
                                        <p className='type-style-3'>{title}</p>
                                    )}
                                    <CarouselNavigation className='hidden sm:flex'/>
                                </div>
                            </div>
                            <div className='layout-container overflow-visible mt-30 md:mt-40'>
                                <Carousel className='swiper-wrapper h-auto'>
                                    <div className=''>
                                        {items.map((item, idx) => {
                                            return (
                                                <React.Fragment key={idx}>
                                                    <CarouselSlide
                                                        className='flex flex-col w-11/12 sm:w-1/2 relative pb-5'
                                                        index={idx}
                                                        key={idx}>
                                                        <ModuleTestimonialItem
                                                            {...item}
                                                            isCarousel={true} />
                                                    </CarouselSlide>
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                </Carousel>
                            </div>
                        </CarouselProvider>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

ModuleTestimonialsCarousel.propTypes = {
    testimonials: PropTypes.shape({
        items: PropTypes.array,
    }),
    title: PropTypes.string,
    parent: PropTypes.string,
};

export default ModuleTestimonialsCarousel;
